import React from 'react'
import {useIntl} from 'react-intl'
import {
    Box,
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const WishlistBreadcrumb = () => {
    const {formatMessage} = useIntl()
    const {buildUrl} = useMultiSite()
    const breadcrumbStyles = useMultiStyleConfig('Breadcrumb', {})
    const styles = useMultiStyleConfig('WishlistPage', {})

    const homeLabel = formatMessage({
        id: 'wishlist.breadcrumb.home',
        defaultMessage: 'Home'
    })

    const wishlistLabel = formatMessage({
        id: 'global.account.link.wishlist',
        defaultMessage: 'Wishlist'
    })

    return (
        <Breadcrumb
            className="sf-breadcrumb"
            data-testid="wishlist-breadcrumb"
            separator="/"
            sx={{
                ...breadcrumbStyles.container,
                ...styles.breadcrumbContainer
            }}
        >
            <BreadcrumbItem data-testid="wishlist-breadcrumb-item">
                <BreadcrumbLink
                    as={Link}
                    to={buildUrl('/')}
                    useNavLink
                    sx={{
                        ...breadcrumbStyles.link,
                        ...breadcrumbStyles.bcText
                    }}
                >
                    {homeLabel}
                </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem isCurrentPage data-testid="wishlist-breadcrumb-item">
                <Box
                    as="span"
                    sx={{
                        ...breadcrumbStyles.link,
                        ...breadcrumbStyles.lastLink,
                        ...breadcrumbStyles.bcText,
                        ...breadcrumbStyles.bcTextLast
                    }}
                >
                    {wishlistLabel}
                </Box>
            </BreadcrumbItem>
        </Breadcrumb>
    )
}

export default WishlistBreadcrumb
